/* eslint-disable camelcase */
const CombinedCoreHours = ({ textData: { step_avg_combined_occupancy_peak_hours } }) =>
  `Throughout the core business hours of the week, the combined office occupancy was generally between
   ${step_avg_combined_occupancy_peak_hours} people.`;

export default CombinedCoreHours;
